import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=29e5f06c&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=29e5f06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e5f06c",
  null
  
)

export default component.exports